export default __webpack_public_path__ + "fe85c1814933624b51a11af51dc366de.jpg";